import {
    SET_CATEGORY_TREE,
    SET_CATEGORY_TREE_ERROR,
    SET_CATEGORY_TREE_SUCCESS,
} from "core-web/state/models/Products/constants";

import GetCategoriesTree from "core-web/libs/GrebbCommerceAPI/Categories/GetCategoriesTree";
import store from "core-web/state/store";

const categoryTreeCleanup = (categoryTree) => {
    return categoryTree.map((category) => {
        const { code, id, level, title, category_img: categoryImage } = category;
        let { children } = category;

        if (children?.length) {
            children = categoryTreeCleanup(children);
        }

        return {
            children,
            code,
            id,
            level,
            title,
            categoryImage,
        };
    });
};

export const setCategoryTree =
    (withDispatch = true, applicationId, url) =>
    async (dispatch, getState) => {
        try {
            const currentState = getState().products.categoryTree;
            if (currentState?.length) {
                return currentState;
            }
            if (withDispatch) {
                dispatch({ type: SET_CATEGORY_TREE });
            }

            try {
                if (!applicationId) {
                    applicationId = getState().application.applicationId;
                }
                const response = await GetCategoriesTree(applicationId, url);

                let categoryTree = [];
                if (response?.data?.length) {
                    categoryTree = categoryTreeCleanup(response.data);
                }

                if (withDispatch) {
                    dispatch({ type: SET_CATEGORY_TREE_SUCCESS, categoryTree });
                }

                return categoryTree;
            } catch (e) {
                if (withDispatch) {
                    dispatch({ type: SET_CATEGORY_TREE_ERROR });
                }
            }
        } catch (e) {
            dispatch({ type: SET_CATEGORY_TREE_ERROR });
            throw e;
        }
    };

export default (withDispatch, applicationId, url) => store.dispatch(setCategoryTree(withDispatch, applicationId, url));
